import { Link } from "react-router-dom";
import { useCart } from "@/context/CartContext";
import { resolveAssetUrl } from "@/lib/api";
import { toast } from "sonner";
import Stars from "@/components/Stars";

const ProductCard = ({ product, rating }) => {
  const { add } = useCart();

  const hasVariants = (product.variants || []).length > 0;

  const handleQuickAdd = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (hasVariants) {
      const inStock = product.variants.find((v) => v.stock > 0);
      if (!inStock) {
        toast.error("Sold out");
        return;
      }
      add(product, { quantity: 1, size: inStock.size, color: inStock.color });
    } else {
      add(product, { quantity: 1 });
    }
  };

  return (
    <Link
      to={`/product/${product.id}`}
      className="group cursor-pointer block"
      data-testid={`product-card-${product.id}`}
    >
      <div className="bg-gradient-to-br from-zinc-900 to-zinc-950 aspect-[3/4] overflow-hidden relative mb-4 flex items-center justify-center">
        {product.badge && (
          <span
            className="absolute top-3 left-3 bg-white text-black font-bold text-[10px] tracking-widest uppercase px-2 py-1 z-10"
            data-testid={`product-badge-${product.id}`}
          >
            {product.badge}
          </span>
        )}
        <img
          src={resolveAssetUrl(product.image_url)}
          alt={product.name}
          className="object-contain w-full h-full p-3 group-hover:scale-105 transition-transform duration-500 opacity-90 group-hover:opacity-100"
        />
        <div className="absolute bottom-4 left-0 w-full px-4 opacity-0 group-hover:opacity-100 transition-opacity">
          <button
            onClick={handleQuickAdd}
            className="w-full bg-black/90 text-white font-heading text-sm py-3 tracking-widest uppercase border border-zinc-700 hover:bg-white hover:text-black transition-colors"
            data-testid={`product-add-${product.id}`}
          >
            Quick Add +
          </button>
        </div>
      </div>
      <h4 className="font-bold tracking-wide uppercase text-sm">
        {product.name}
      </h4>
      <div className="flex items-center justify-between mt-1">
        <p className="text-zinc-400 text-xs">
          ${Number(product.price).toFixed(2)}
        </p>
        {rating && rating.count > 0 && (
          <div
            className="flex items-center gap-1.5"
            data-testid={`product-rating-${product.id}`}
          >
            <Stars rating={rating.average} size={11} />
            <span className="text-[10px] text-zinc-500 tracking-wider">
              ({rating.count})
            </span>
          </div>
        )}
      </div>
    </Link>
  );
};

export default ProductCard;
